import React from "react";

import { Pagination } from "@/components/common/controls/Pagination";

import { useCrudListContext } from "./CrudListContext";

export const CrudListPagination: React.FC = () => {
  const {
    currentPage,
    total,
    offset,
    limit,
    hasMore,
    isManualLoading,
    knownPageCount,
    loadNextListPage,
    loadSpecificListPage
  } = useCrudListContext();

  return (
    <Pagination
      currentPage={currentPage}
      disabled={isManualLoading}
      hasMore={hasMore}
      limit={limit}
      total={total}
      offset={offset}
      pageCount={knownPageCount}
      onChange={loadSpecificListPage}
      onNext={loadNextListPage}
    />
  );
};
